import cx from 'classnames';
import { AppDatePicker } from "../../core/AppDatePicker";
import { constantToDisplayName } from "../../core/constantToDisplayName";
import { ProductType } from 'legoland-sdk/dist/experimental';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Box, Button, FormGroup, Heading, Label, Text, TooltipOnHover, tombac, useToasts, useTombac } from 'tombac';
import { CopyIcon, ErrorIcon } from 'tombac-icons';
import { useUserDetails } from "../../users/UserDetailsProvider";
import { useAccessHistoryQuery, useCheckApiKeyQuery } from "../../users/api/userManagementApiHooks";
import { AccessHistoryModal } from "./AccessHistoryModal";
import LimitsSummary from "./LimitsSummary";
import "./ProductForm.css";
import { ProductLogo } from "./ProductLogo";
import { accessIconMap } from "./accessIconMap";
import { statusIconMap } from "./statusIconMap";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function ProductForm(props) {
  const {
    packaged,
    showProductDetails,
    values
  } = props;
  const active = values.resell || values.access;
  if (!active) return null;
  return /*#__PURE__*/_jsxs("div", {
    className: cx('Product', active && 'Product--active', packaged && 'Product--packaged'),
    "data-product-id": values.id,
    "data-sentry-component": "ProductForm",
    "data-sentry-source-file": "ProductForm.tsx",
    children: [/*#__PURE__*/_jsx("div", {
      className: "Product__image",
      children: /*#__PURE__*/_jsx(ProductLogo, {
        productId: values.id,
        "data-sentry-element": "ProductLogo",
        "data-sentry-source-file": "ProductForm.tsx",
        "data-sentry-element": "ProductLogo"
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: "Product__info",
      children: [/*#__PURE__*/_jsx(ProductHeader, {
        ...props,
        active: active,
        "data-sentry-element": "ProductHeader",
        "data-sentry-source-file": "ProductForm.tsx",
        "data-sentry-element": "ProductHeader"
      }), (showProductDetails || values.resell) && /*#__PURE__*/_jsx(_Fragment, {
        children: /*#__PURE__*/_jsx("div", {
          className: "Product__details",
          children: /*#__PURE__*/_jsxs("div", {
            className: "Product__params",
            children: [showProductDetails && /*#__PURE__*/_jsxs(_Fragment, {
              children: [/*#__PURE__*/_jsx(AccessTypeField, {
                ...props
              }), /*#__PURE__*/_jsx(StatusField, {
                ...props
              }), /*#__PURE__*/_jsx(StartDateField, {
                ...props
              }), /*#__PURE__*/_jsx(ExpiryDateField, {
                ...props
              })]
            }), values.resell && /*#__PURE__*/_jsx(ResellUntilField, {
              ...props
            })]
          })
        })
      })]
    }), values.access && /*#__PURE__*/_jsx(LimitsSummary, {
      ...props,
      className: "Product__limits",
      headerClassName: "Product__limits-header",
      product: values
    })]
  });
}
function ProductHeader(props) {
  const {
    values,
    showApiKey
  } = props;
  const userDetails = useUserDetails();
  const historyQuery = useAccessHistoryQuery({
    username: userDetails?.email
  }, {
    enabled: !!userDetails
  });
  const [isHistoryOpen, setIsHistoryOpen] = useState(false);
  return /*#__PURE__*/_jsxs("div", {
    className: "Product__header",
    "data-sentry-component": "ProductHeader",
    "data-sentry-source-file": "ProductForm.tsx",
    children: [/*#__PURE__*/_jsx("div", {
      className: "Product__name",
      children: /*#__PURE__*/_jsx(Heading, {
        as: "span",
        className: "Product__name-heading",
        level: 4,
        "data-sentry-element": "Heading",
        "data-sentry-source-file": "ProductForm.tsx",
        "data-sentry-element": "Heading",
        children: values.displayName
      })
    }), /*#__PURE__*/_jsxs(Box, {
      $display: "flex",
      $flexDirection: "column",
      $gap: "0.5sp",
      "data-sentry-element": "Box",
      "data-sentry-source-file": "ProductForm.tsx",
      "data-sentry-element": "Box",
      children: [values.apiKey && values.access && showApiKey && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(ApiKeyField, {
          ...props
        }), values.developerId && /*#__PURE__*/_jsx(DeveloperIdField, {
          ...props
        })]
      }), values.contractAccessId && /*#__PURE__*/_jsx(ContractLink, {
        contractId: values.contractAccessId
      }), values.resellContract && /*#__PURE__*/_jsx(ContractLink, {
        distribution: true,
        contractId: values.resellContract.id
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: "Product__advanced-access",
      children: userDetails && /*#__PURE__*/_jsx(_Fragment, {
        children: historyQuery.data?.history[values.id]?.length > 0 && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(AccessHistoryModal, {
            isOpen: isHistoryOpen,
            onRequestClose: () => setIsHistoryOpen(false),
            productId: values.id
          }), /*#__PURE__*/_jsx(Text, {
            as: "button",
            onClick: () => setIsHistoryOpen(true),
            variant: "interactive",
            children: "Access history"
          })]
        })
      })
    })]
  });
}
function ContractLink({
  contractId,
  distribution = false
}) {
  return /*#__PURE__*/_jsxs(Text, {
    $mt: '1sp',
    "data-sentry-element": "Text",
    "data-sentry-component": "ContractLink",
    "data-sentry-source-file": "ProductForm.tsx",
    children: [distribution ? 'Distribution' : 'Access', " values are defined in the", ' ', /*#__PURE__*/_jsx(ContractLinkStyled, {
      to: `/contracts/${contractId}`,
      "data-sentry-element": "ContractLinkStyled",
      "data-sentry-source-file": "ProductForm.tsx",
      "data-sentry-element": "ContractLinkStyled",
      children: "contract"
    })]
  });
}
function AccessTypeField({
  values
}) {
  const AccessIcon = accessIconMap[values.accessType];
  return /*#__PURE__*/_jsx(FormGroup, {
    label: "Access type",
    "data-sentry-element": "FormGroup",
    "data-sentry-component": "AccessTypeField",
    "data-sentry-source-file": "ProductForm.tsx",
    children: /*#__PURE__*/_jsxs("div", {
      className: "Product__readonly-value Product__access-type-value",
      children: [/*#__PURE__*/_jsx(AccessIcon, {
        "data-sentry-element": "AccessIcon",
        "data-sentry-source-file": "ProductForm.tsx",
        "data-sentry-element": "AccessIcon"
      }), " ", constantToDisplayName(values.accessType), ' ']
    })
  });
}
function StatusField({
  values
}) {
  const tombac = useTombac();
  const user = useUserDetails();
  const historyQuery = useAccessHistoryQuery({
    username: user.email
  });
  const status = historyQuery.data?.history[values.id][0]?.status;
  if (!status) {
    return null;
  }
  const StatusIcon = statusIconMap[status].icon;
  const statusIconColor = tombac.color(...statusIconMap[status].color);
  return /*#__PURE__*/_jsx(FormGroup, {
    label: "Status",
    "data-sentry-element": "FormGroup",
    "data-sentry-component": "StatusField",
    "data-sentry-source-file": "ProductForm.tsx",
    children: /*#__PURE__*/_jsxs("div", {
      className: "Product__readonly-value",
      children: [/*#__PURE__*/_jsx(StatusIcon, {
        color: statusIconColor,
        "data-sentry-element": "StatusIcon",
        "data-sentry-source-file": "ProductForm.tsx",
        "data-sentry-element": "StatusIcon"
      }), " ", constantToDisplayName(status)]
    })
  });
}
function StartDateField({
  values
}) {
  const user = useUserDetails();
  const historyQuery = useAccessHistoryQuery({
    username: user.email
  });
  const productHistory = historyQuery.data?.history[values.id];
  const historyStartDate = productHistory && productHistory[0]?.startDate;
  const [startDate, setStartDate] = useState(new Date());
  useEffect(() => {
    if (historyStartDate) {
      setStartDate(historyStartDate ? moment.utc(historyStartDate).toDate() : new Date());
    }
  }, [historyStartDate]);
  const id = `${values.id}_start-date`;
  return /*#__PURE__*/_jsx(FormGroup, {
    className: "Product__start-date",
    htmlFor: id,
    label: "Starts on",
    "data-sentry-element": "FormGroup",
    "data-sentry-component": "StartDateField",
    "data-sentry-source-file": "ProductForm.tsx",
    children: /*#__PURE__*/_jsx(AppDatePicker, {
      disabled: true,
      id: id,
      value: startDate,
      "data-sentry-element": "AppDatePicker",
      "data-sentry-source-file": "ProductForm.tsx",
      "data-sentry-element": "AppDatePicker"
    })
  });
}
function ExpiryDateField({
  onChange,
  values,
  hasUserContracts
}) {
  const id = `${values.id}_expiry-date`;
  return /*#__PURE__*/_jsx(FormGroup, {
    className: "Product__expiry-date",
    htmlFor: id,
    label: "Expires on",
    "data-sentry-element": "FormGroup",
    "data-sentry-component": "ExpiryDateField",
    "data-sentry-source-file": "ProductForm.tsx",
    children: /*#__PURE__*/_jsx(AppDatePicker, {
      id: id,
      maxDate: moment.utc().add(10, 'years').toDate(),
      onChange: value => onChange(values => ({
        ...values,
        expiryDate: value
      })),
      placeholder: "Select",
      value: values.expiryDate && moment.utc(values.expiryDate).toDate(),
      $width: "17sp",
      disabled: hasUserContracts,
      "data-sentry-element": "AppDatePicker",
      "data-sentry-source-file": "ProductForm.tsx",
      "data-sentry-element": "AppDatePicker"
    })
  });
}
function ApiKeyField({
  values
}) {
  const tombac = useTombac();
  const {
    addToast
  } = useToasts();
  const [isMasked, setIsMasked] = useState(true);
  const checkApiKeyQuery = useCheckApiKeyQuery({
    productId: values.id,
    apiKey: values.apiKey
  });
  const legitimate = checkApiKeyQuery.data?.result.legitimate;
  const textColor = legitimate === false ? tombac.color('primary', 500) : isMasked ? tombac.color('neutral', 500) : tombac.color('neutral', 600);
  const apiKey = isMasked ? values.apiKey.slice(-4).padStart(values.apiKey.length - 4, '⦁') : values.apiKey;
  const clientApiKey = legitimate === false ? /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs(Box, {
      $display: "flex",
      children: [apiKey, ' ', /*#__PURE__*/_jsxs(TooltipOnHover, {
        content: "Your API key is invalid. Please contact MOVE support.",
        placement: "top",
        size: "s",
        variant: "danger",
        children: [' ', /*#__PURE__*/_jsx(ErrorIcon, {
          color: tombac.color('danger')
        })]
      })]
    })
  }) : apiKey;
  const handleCopyClick = async () => {
    try {
      await navigator.clipboard.writeText(values.apiKey);
      addToast('The API key is copied to the clipboard', 'success');
    } catch (e) {
      addToast('Failed to copy the API key to the clipboard', 'danger');
    }
  };
  return values.productType === ProductType.PortalWithApi ? /*#__PURE__*/_jsxs(Box, {
    $alignItems: "center",
    $display: "flex",
    $gap: "1sp",
    className: "Product__api-key",
    onMouseLeave: () => setIsMasked(true),
    children: [/*#__PURE__*/_jsx(Label, {
      $color: tombac.color('neutral', 700),
      as: "div",
      children: "API key:"
    }), /*#__PURE__*/_jsx(Text, {
      $color: textColor,
      $mt: "0.2em",
      as: "div",
      onMouseEnter: () => setIsMasked(false),
      children: clientApiKey
    }), /*#__PURE__*/_jsx(Button, {
      onClick: handleCopyClick,
      shape: "circle",
      size: "xs",
      variant: "flat",
      children: /*#__PURE__*/_jsx(CopyIcon, {})
    })]
  }) : null;
}
function DeveloperIdField({
  values
}) {
  const tombac = useTombac();
  const {
    addToast
  } = useToasts();
  const developerId = values.developerId;
  if (!developerId) {
    return null;
  }
  const textColor = tombac.color('neutral', 600);
  const handleCopyClick = async () => {
    try {
      await navigator.clipboard.writeText(developerId);
      addToast('The developer ID is copied to the clipboard', 'success');
    } catch (e) {
      addToast('Failed to copy the developer ID to the clipboard', 'danger');
    }
  };
  return values.productType === ProductType.PortalWithApi ? /*#__PURE__*/_jsxs(Box, {
    $alignItems: "center",
    $display: "flex",
    $gap: "1sp",
    children: [/*#__PURE__*/_jsx(Label, {
      $color: tombac.color('neutral', 700),
      as: "div",
      children: "Developer ID:"
    }), /*#__PURE__*/_jsx(Text, {
      $color: textColor,
      $mt: "0.2em",
      as: "div",
      children: developerId
    }), /*#__PURE__*/_jsx(Button, {
      onClick: handleCopyClick,
      shape: "circle",
      size: "xs",
      variant: "flat",
      children: /*#__PURE__*/_jsx(CopyIcon, {})
    })]
  }) : null;
}
function ResellUntilField({
  onChange,
  values,
  hasUserContracts
}) {
  const id = `${values.id}_resell-until`;
  return values.resell && /*#__PURE__*/_jsx(FormGroup, {
    htmlFor: id,
    label: "Resell until",
    children: /*#__PURE__*/_jsx(AppDatePicker, {
      id: id,
      maxDate: moment.utc().add(10, 'years').toDate(),
      onChange: value => onChange(values => ({
        ...values,
        resellUntil: value
      })),
      placeholder: "Select",
      value: values.resellUntil && moment.utc(values.resellUntil).toDate(),
      $width: "17sp",
      disabled: hasUserContracts
    })
  });
}
const ContractLinkStyled = styled(Link).withConfig({
  displayName: "ProductForm__ContractLinkStyled"
})(["color:", ";"], tombac.color('accent', 600));